import { createContext } from "react";
import { sponsorInitialState } from "./sponsorInitialState";


const SponsorContext = createContext(sponsorInitialState)

export default SponsorContext